export enum ImportStatus {
    Start = 'Start',
    Importing = 'Importing',
    Success = 'Success',
    Error = 'Error',
}

export interface State {
    status: ImportStatus;
    importTextStatus?: string;
    progress?: number;
    key?: string;
}